<template>
  <v-container style="width:800px;">
    <v-card>
      <v-container>
        <v-card-title>業務連絡登録</v-card-title>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea
              v-model="notice"
              outline
              clearable
              label="業務連絡内容"
              v-validate="'required'"
              data-vv-name="businessContact"
              :error-messages="errors.collect('businessContact')"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 sm6>
            <v-switch v-model="switch1" label="重要な業務連絡" color="red darken-3" value="1" hide-details></v-switch>
          </v-flex>

          <v-flex xs6 sm6>
            <v-btn block color="success" dark @click="newContact()">
              <v-icon dark left>save</v-icon>業務連絡を登録する
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <br />

    <v-card>
      <v-container>
        <v-card-title>業務連絡一覧</v-card-title>

        <v-data-table
          :headers="headers"
          :items="businessContacts"
          class="elevation-1"
          hide-actions
          disable-initial-sort
        >
          <template v-slot:items="props">
            <td class="text-xs-left" style="display: none">{{ props.item.businessContactId }}</td>
            <td>
              <v-checkbox v-model="props.item.isDeleted" value="1" primary hide-details></v-checkbox>
            </td>
            <td class="text-xs-left">
              <v-icon
                v-if="props.item.isImportant === '1'"
                color="red darken-3"
                @click="editImportant(props.item)"
              >report</v-icon>
              <v-icon v-else color="blue-grey lighten-4" @click="editImportant(props.item)">report</v-icon>
            </td>
            <td class="text-xs-left">{{ props.item.createdAt }}</td>
            <td
              class="text-xs-left"
              style="white-space:pre-wrap; word-wrap:break-word;"
            >{{ props.item.notice }}</td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-layout row wrap style="margin-top:  30px; margin-bottom: 50px;">
      <v-flex xs12 sm5>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
      </v-flex>
      <v-flex xs12 sm2></v-flex>
      <v-flex xs12 sm5>
        <v-btn block color="error" dark @click="deleteContacts()">
          <v-icon dark left>delete_forever</v-icon>選択した業務連絡を削除する
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-container>
          <v-card-title>
            <span class="headline">重要度設定</span>
          </v-card-title>
          <v-layout row wrap align-center>
            <v-flex>
              <v-select
                v-model="editingBusinessContact.isImportant"
                :items="importants"
                item-text="importantName"
                item-value="isImportant"
                label="重要度"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">
              <v-icon dark>arrow_back</v-icon>戻る
            </v-btn>
            <v-btn color="blue darken-1" flat @click="save">
              <v-icon dark>save</v-icon>変更
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.refreshContacts()
  },
  methods: {
    refreshContacts() {
      let thisObj = this
      thisObj.loading = true

      ServerApiCallService.businessContacts()
        .then(response => {
          thisObj.businessContacts = response.data.businessContacts
          thisObj.businessContacts.forEach(function(row) {
            let formattedCreatedAt =
              row.createdAt.substring(0, 4) +
              '/' +
              row.createdAt.substring(4, 6) +
              '/' +
              row.createdAt.substring(6, 8)
            row.createdAt = formattedCreatedAt
          })

          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    newContact() {
      console.log('new contact')
      let thisObj = this

      let isImportant = this.switch1 == '1' ? '1' : '0'

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        isImportant: isImportant,
        notice: this.notice
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
        thisObj.loading2 = true
        ServerApiCallService.businessContactsPost(request, sendContext)
          .then(response => {
            console.log('completed new contacts')
            thisObj.loading2 = false

            let businessContact = response.data.businessContact
            let formattedCreatedAt =
              businessContact.createdAt.substring(0, 4) +
              '/' +
              businessContact.createdAt.substring(4, 6) +
              '/' +
              businessContact.createdAt.substring(6, 8)
            businessContact.createdAt = formattedCreatedAt

            thisObj.businessContacts.unshift({
              businessContactId: businessContact.businessContactId,
              notice: businessContact.notice,
              isImportant: businessContact.isImportant,
              createdAt: businessContact.createdAt
            })
            ;(this.notice = ''), (this.switch1 = '0')
            this.$validator.reset()
          })
          .catch(error => {
            thisObj.loading2 = false
            console.log('There was an error:', error.response)
          })
      })
    },
    deleteContacts() {
      console.log('delete contacts')
      let thisObj = this
      thisObj.loading2 = true

      let request = {
        deleteContacts: []
      }
      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      this.businessContacts.forEach(function(row) {
        if (row.isDeleted === '1') {
          request.deleteContacts.push(row)
        }
      })

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.businessContactsDelete(request, sendContext)
        .then(() => {
          console.log('completed new contacts')
          thisObj.loading2 = false
          thisObj.refreshContacts()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    editImportant(item) {
      let thisObj = this
      console.log('open edit contact important')
      thisObj.businessContacts.forEach(function(row) {
        if (row.businessContactId === item.businessContactId) {
          thisObj.importants.forEach(function(important) {
            if (important.isImportant === item.isImportant) {
              thisObj.editingBusinessContactId = item.businessContactId
              thisObj.editingBusinessContact = {
                importantName: important.importantName,
                isImportant: important.isImportant
              }
            }
          })
        }
      })
      this.dialog = true
    },
    save() {
      console.log('save dialog')
      let thisObj = this
      let sendRequest = {
        businessContactId: this.editingBusinessContactId,
        isImportant: this.editingBusinessContact.isImportant
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.businessContactsImportantPut(
        sendRequest,
        sendContext
      )
        .then(() => {
          thisObj.businessContacts.forEach(function(row) {
            if (row.businessContactId === thisObj.editingBusinessContactId) {
              row.isImportant = thisObj.editingBusinessContact.isImportant
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      // Object.assign(this.tableDatas[this.editedIndex], this.editedItem)
      this.close()
    },
    close() {
      this.dialog = false
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,

      notice: '',
      switch1: '0',

      dialog: false,
      editingBusinessContactId: '',
      editingBusinessContact: '',

      importants: [
        {
          importantName: '通常',
          isImportant: '0'
        },
        {
          importantName: '重要',
          isImportant: '1'
        }
      ],

      headers: [
        { text: '選択', value: 'businessContactId', sortable: false },
        { text: '重要', value: 'isImportant', sortable: false },
        { text: '登録日', value: 'createdAt' },
        { text: '連絡項目', value: 'notice', sortable: false }
      ],
      businessContacts: []
    }
  }
}
</script>

<style lang="scss" scoped></style>
